import { OrderMode } from '../../types/graphql'

export type Nullable<T> = T | null | undefined
export type NullablePartial<T> = { [P in keyof T]?: T[P] | null }

export type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T
}

export type RefetchFnType = () => Promise<unknown>

export interface MakeOrderInput<FiltersType = any> {
  mode: OrderMode
  fieldName: keyof FiltersType
}

export type MakeOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

type Without<T, U> = { [P in Exclude<keyof T, keyof U>]?: never }
export type XOR<T, U> = (T & Without<U, T>) | (U & Without<T, U>)

export type Suffix<TKeyUnion extends string, TPrefix extends string> = {
  [TKey in TKeyUnion]: TKey extends `${TPrefix}${infer TSuffix}` ? TSuffix : never
}[TKeyUnion]

export enum KeyboardKey {
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  ArrowUp = 'ArrowUp',
  Backslash = '\\',
  Backspace = 'Backspace',
  Delete = 'Delete',
  Enter = 'Enter',
  Equals = '=',
  Escape = 'Escape',
  F = 'f',
  Minus = '-',
  K = 'k',
  Space = ' ',
  Tab = 'Tab',
}

export type ValidationOutcome =
  | {
      isValid: true
      invalidReason?: never
    }
  | {
      isValid: false
      invalidReason: string
    }

export enum LocalStorageKey {
  AIAssistantHistoryTabKey = 'AIAssistantHistoryTabKey',
  AIAssistantSettingsTabKey = 'AIAssistantSettingsTabKey',
  AIAssistantTrainTabKey = 'AIAssistantTrainTabKey',
  AIPageTabKey = 'AIPageTabKey',
  ArcgisBasemapKey = 'ArcgisBasemapKey',
  CalendarPageUserIdsFilterKey = 'CalendarPageUserIdsFilterKey',
  CompanyPageTabKey = 'CompanyPageTabKey',
  FeeSchedulesTabKey = 'FeeSchedulesTabKey',
  FilePageDiffViewMode = 'FilePageDiffViewMode',
  FilePagePreviousVersionsById = 'FilePagePreviousVersionsById',
  HasClosedAIAssistantModal = 'HasClosedAIAssistantModal',
  InspectionCalendarsTabKey = 'InspectionCalendarsTabKey',
  LastSelectedOrgId = 'LastSelectedOrgId',
  MobileAppBannerDismissed = 'MobileAppBannerDismissed',
  LastSubmittedApplicantCompanyId = 'LastSubmittedApplicantCompanyId',
  LightnessMode = 'LightnessMode',
  ModuleSettingsMenuKey = 'ModuleSettingsMenuKey',
  NavigationCodeV1IsOpen = 'NavigationCodeV1IsOpen',
  NavigationRecordTypeIsOpenMap = 'NavigationRecordTypeIsOpenMap',
  OrganizationPageTabKey = 'OrganizationPageTabKey',
  PlanReviewCommentSortMode = 'PlanReviewCommentSortMode',
  RecordIndividualReportSelectedSections = 'RecordIndividualReportSelectedSections',
  RecordInspectionViewType = 'RecordInspectionViewType',
  RecordTemplateFormStateMap = 'RecordTemplateFormStateMap',
  SeenAlerts = 'SeenAlerts',
  SidebarIsCollapsed = 'SidebarIsCollapsed',
  SkipCreateTestRecordModal = 'SkipCreateTestRecordModal',
  TableViewManagers = 'TableViewManager',
  UserPageTabKey = 'UserPageTabKey',
}

export enum PlanReviewCommentSortMode {
  DateDesc = 'date_desc',
  DateAsc = 'date_asc',
  PageAsc = 'page_asc',
  PageDesc = 'page_desc',
}

export enum SessionStorageKey {
  ActiveOrgId = 'activeOrgId',
}

export enum BroadcastChannelMessageType {
  AuthenticationCheck = 'AuthenticationCheck',
  AuthenticationACK = 'AuthenticationACK',
  ChangeLightnessMode = 'ChangeLightnessMode',
  Logout = 'Logout',
}

export enum Month {
  January = 1,
  February = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12,
}

export type MapModeType = 'none' | 'modal' | 'inline'
